
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'upt'
    })
  } // computed
}; // export default
